export default __webpack_public_path__ + "static/wallet.url-b59fde9107179315adac43979571c87f.svg";